<template>
  <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="120px">
      <el-form-item label="标签组" prop="groupName">
        <el-input v-model="form.groupName" placeholder="请输入标签组名称" />
      </el-form-item>
      <el-form-item label="状态">
        <el-switch v-model="form.tagStatus" :active-value="1" :inactive-value="0"></el-switch>{{form.tagStatus?'启用':'禁用'}}
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import ImageUpload from "@/components/ImageUpload";
import clientLabelApi from '@/api/client/label'

function initFormBean() {
  const formBean = {
    id: null,
    tagStatus: 1,
    groupName: '',
  }
  return formBean
}

export default {
  components: {
    ImageUpload
  },
  data() {
    return {
      form: initFormBean(),
      isLoading: false,
      formVisible: false,
      formRules: {
        groupName: [{
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        }],
      },
      isRepSub: false
    }
  },
  created() {

  },
  methods: {
    resetForm() {
      this.form = initFormBean()
    },
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row }
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.form.id > 0) {
            clientLabelApi.update1(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            clientLabelApi.create1(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}

.input-box {
  display: flex;
  align-items: center;
  // margin-bottom: 18px;
}

.input-box:last-child {
  margin-bottom: 0;
}

::v-deep .el-icon-plus,
.el-icon-minus {
  margin-left: 4px;
  color: #60b7dc;
}
</style>
